<template>
    <div id="videoPanel">
        <popup ref="popup" type="center" @close="popClose">
            <div class="video_dialog">
                <div class="dialog_close" @click="closeDialog"></div>
                <div class="dialog_header">
                    <div class="title_text">如何一分钟写一篇1000字的文章，要求：原创</div>
                    <div class="title_desc">
                        <div class="desc_text">花一分钟的时间看完下面懒人办公的几大亮点（当然还有更多），相信用不了一分钟，你也能成为大家眼中才华横溢的写作家！</div>
                        <div class="play_count">播放次数：316516516 次</div>
                    </div>
                </div>
                <div class="dialog_body">
                    <div class="video_list">
                        <div @click="selectVideo(index)" :class="['video_item',{'active':videoIndex==index}]" v-for="(v,index) in video_list">
                            <div class="hot_icon" v-if="v.hot"></div>
                            <div class="video_name"><span>{{ v.name }}</span><img v-if="v.is_read==0" class="no_read" src="./img/no_read.png"></div>
                            <div class="video_desc">{{ v.desc }}</div>
                        </div>
                    </div>
                    <div class="video_wrap">
                        <div class="video_main">
                            <video class="video_ele" @pause="videoPause=true" @play="videoPause=false" controls ref="video" :src="videoUrl"></video>
                            <div class="pause_cover" @click="playVideo" v-show="videoPause">
                                <img class="play_icon" src="./img/img_icon_13.png" alt="">
                                <div class="pause_text">点击观看</div>
                                <div class="cover_text">懒人办公可以把学术教育、活动方案、文章改写、工作汇报、年终总结、自媒体、小说、情书、公文、短视频文案、广告营销、规章制度等一键激发灵感，自动写作原创内容。只要是你想写的，没有懒人办公不能写的！</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </popup>
    </div>
</template>
<script type="text/ecmascript-6">
    import popup from "COMPONENTS/Popup.vue"
    import Cookies from 'js-cookie'
    export default {
        components:{popup},
        data() {
            return {
                tutorialVisible:false,
                video_list:[
                    {
                        is_read:1,
                        name:"短文写作",
                        desc:"所有文章，一键自动生成",
                        video_url:"https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/aixz/duwenxiezuo.mp4",
                    },
                    {
                        is_read:0,
                        name:"长文写作",
                        desc:"根据提纲生成你想要的文章",
                        video_url:"https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/aixz/longwrite.mp4",
                    },
                    {
                        is_read:0,
                        name:"划词修改",
                        desc:"灵活Ai编辑，功能超级强大",
                        video_url:"https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/aixz/huodonggaixie.mp4",
                        hot:1
                    },
                    {
                        is_read:0,
                        name:"文档分享",
                        desc:"一键加密分享，安全便捷",
                        video_url:"https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/aixz/jiamishare.mp4",
                    },
                    {
                        is_read:0,
                        name:"百套模板",
                        desc:"使用模板，生成专业内容",
                        video_url:"https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/aixz/applist.mp4",
                    },
                    {
                        is_read:0,
                        name:"快捷访问",
                        desc:"一键添加，下次一目了然",
                        video_url:"https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/aixz/quickaccess.mp4",
                    },
                ],
                videoIndex:0,
                videoUrl:"https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/aixz/duwenxiezuo.mp4",
                videoPause:true
            }
        },
        created() {
            let i = 0
            this.video_list.forEach(v => {
                if(i==0){

                }else{
                    v.is_read = localStorage.getItem("video_"+i) || 0
                }
                i += 1
            })
        },
        computed:{
            isLogin(){
                return this.$store.state.isLogin;
            }
        },
        mounted(){
            // // let show_video = localStorage.getItem("show_video") || 0
            // let show_video = Cookies.get("show_video") || 0
            // let token = localStorage.getItem("token") || ""
            // // if(show_video==0&&token){
            // if(show_video==0){
            //    this.show()
            //     // localStorage.setItem("show_video",1)
            //     Cookies.set("show_video", 1)
            // }else{
            //     show_video += 1
            //     Cookies.set("show_video", show_video)
            // }
        },
        methods: {
            show(){
                this.$refs.popup.show();
            },
            popClose(){
                this.$refs.video.pause();
            },
            closeDialog(){
                this.$refs.video.pause();
                this.$refs.popup.close();
            },
            selectVideo(i){
                this.videoPause = true
                this.videoIndex = i;
                this.videoUrl = this.video_list[i].video_url;
                this.video_list[this.videoIndex].is_read = localStorage.getItem("video_"+this.videoIndex) || 0
            },
            playVideo(){
                localStorage.setItem("video_"+this.videoIndex,1);
                this.video_list[this.videoIndex].is_read = 1
                this.$refs.video.play();
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .video_dialog{
        width: 1160px;
        position: relative;
        // padding: 0 20px 20px;
        background-color: #fff;
        border-radius: 3px;
        .dialog_close{
            width: 30px;
            height: 30px;
            border-radius: 15px;
            background-color: #000;
            background-image: url("./img/update_close.png");
            background-size: 16px 16px;
            background-repeat: no-repeat;
            background-position: center;
            position: absolute;
            top: 0;
            right: -46px;
            cursor: pointer;
        }
        .dialog_header{
            padding: 12px 24px;
            border-bottom: 1px solid #ddd;
            box-shadow: 0 10px 10px -5px #e9e9e9;
            .title_text{
                font-size: 24px;
                font-weight: bold;
                line-height: 42px;
            }
            .title_desc{
                display: flex;
                justify-content: space-between;
                line-height: 28px;
                .desc_text{
                    color: #999;
                }
                .play_count{
                    color: #07c160;
                }
            }
        }
        .dialog_body{
            display: flex;
            overflow: hidden;
            .video_list{
                width: 215px;
                flex-shrink: 0;
                border-right: 1px solid #ddd;
                box-shadow: 10px 0 10px -5px #e9e9e9;
                padding: 28px 30px 28px 24px;
                .video_item{
                    height: 56px;
                    border-radius: 3px;
                    background-color: #ddd;
                    position: relative;
                    padding-left: 8px;
                    cursor: pointer;
                    &:not(:last-child){
                        margin-bottom: 24px;
                    }
                    &.active{
                        background-color: #07c160;
                        .hot_icon{
                            background-image: url("./img/jiangchong.png");
                        }
                        .video_name{
                            color: #fff;
                        }
                        .video_desc{
                            color: #fff;
                        }
                        &::after{
                            content: "";
                            display: block;
                            border: 8px solid transparent;
                            border-left-color: #07c160;
                            position: absolute;
                            top: 50%;
                            right: -16px;
                            margin-top: -8px;
                        }
                    }
                    .hot_icon{
                        position: absolute;
                        width: 36px;
                        height: 36px;
                        top: 0;
                        right: 0;
                        background-size: 100% 100%;
                        background-image: url("./img/jiangchong1.png");
                    }
                    .video_name{
                        padding-top: 6px;
                        font-size: 13px;
                        line-height: 23px;
                        display:flex;
                        .no_read{
                            width:24px;
                            margin-left:5px;
                        }
                    }
                    .video_desc{
                        font-size: 12px;
                        color: #999;
                        line-height: 22px;
                    }
                }
            }
            .video_wrap{
                flex-grow: 1;
                padding: 28px;
                .video_main{
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    background-color: #eeeeee;
                    border-radius: 4px;
                    position: relative;
                    .video_ele{
                        width: 100%;
                        height: 100%;
                    }
                    .pause_cover{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.6);
                        cursor: pointer;
                        padding-top: 120px;
                        .play_icon{
                            display: block;
                            margin: 0 auto;
                            margin-bottom: 15px;
                        }
                        .pause_text{
                            text-align: center;
                            font-size: 15px;
                            color: #fff;
                            line-height: 35px;
                        }
                        .cover_text{
                            width: 758px;
                            margin: 90px auto 0;
                            border-radius: 5px;
                            background-color: #000;
                            color: #4d4d4d;
                            line-height: 28px;
                            padding: 16px 22px;
                        }
                    }
                }
            }
        }
    }
</style>